<script setup lang="ts">
import type { NovaBoxHomeActionButtonProps } from './NovaBoxHomeActionButton.types'

defineProps<NovaBoxHomeActionButtonProps>()
</script>

<template>
  <button type="button" :class="['btn-toggle', { loading }]">
    <div class="icon-wrap">
      <span class="shade"></span>
      <NovaIcon
        :icon="{ type: 'outline', name: 'more-vertical' }"
        :size="16"
        class="icon"
      />
      <NovaLoadingIndicator
        v-if="loading"
        class="loading-indicator"
        :bg-bright="'light'"
      />
    </div>
  </button>
</template>

<style lang="scss" scoped>
@mixin on {
  .icon-wrap {
    > .shade {
      transform: translate(-50%, -50%) scale(1);
    }

    > .icon {
      color: $color-text-2;
    }
  }
}

.btn-toggle {
  display: flex;
  gap: 8px;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      @include on;
    }
  }

  &:active,
  &.on {
    @include on;
  }

  &.loading {
    .icon-wrap {
      > .icon {
        opacity: 0.4;
      }
    }
  }

  .icon-wrap {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;

    > .shade {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 36px;
      height: 36px;
      border-radius: 8px;
      transform: translate(-50%, -50%) scale(0);
      background-color: hex-to-rgba($color-bg-1, 0.2);
      @include transition(transform 0.2s);
      z-index: 1;
    }

    > .icon {
      color: #000000;
      @include transition(transform 0.2s);
      z-index: 2;
    }

    > .loading-indicator {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 60px;
      height: 60px;
      transform: translate(-50%, -50%);
      z-index: 2;
      pointer-events: none;
    }
  }

  @include mobile {
    gap: 6px;
  }
}
</style>
